import type { CoreApiClient } from "../client";
import { createBuildingMutations } from "../mutations/building.mutations";
import { createBuildingQueries } from "../queries/building.queries";

export const createBuildingRepository = (api: CoreApiClient) => ({
  ...createBuildingQueries(api),
  ...createBuildingMutations(api),
});
